<template lang="pug">
  div.custom-input-table-wrapper
    v-data-table.custom-input-table(
      class="common-table-container custom-arrow-key"
      :id="tableId"
      :ref="tableId"
      :headers="headers"
      :items="items"
      :items-per-page="-1"
      hide-default-header
      hide-default-footer
      item-key="id"
      fixed-header
      mobile-breakpoint="0"
    )
      template(v-slot:header="{ props: { headers } }")
        thead(class="v-data-table-header")
          tr
            th(
                v-for="header in headers"
                :key="header.value"
                :style="{ top: stickyTopPos, minWidth: header.width }"
                class="column"
                :class="[header.sortable ? 'sortable' : '', sortInfo.sortBy === header.value ? 'active': '', sortInfo.isDescending ? 'desc':'asc']"
                @click="header.sortable ? changeSort(header) : ''"
            )
              div(v-if="header.cellType === CELL_TYPE.checkbox")
                div.border-checkbox.wrapper-header(:style="{justifyContent: header?.headerAlign ? header?.headerAlign : ''}")
                  span(v-if="!header.isShowCheckboxAll") {{ header.text }}
                  v-simple-checkbox(
                    v-else
                    @input="(value) => onInputHeaderCheckbox(value, header)"
                    v-model="header.isSelectAll"
                    color="primary"
                  )
              div(v-else).wrapper-header.text-center(:style="{justifyContent: header?.headerAlign ? header?.headerAlign : ''}")
                v-icon(v-if="header.sortable" color="white") mdi-swap-vertical
                span {{ header.text }}
                v-icon(v-if="header.sortable" class="v-data-table-header__icon" color="white") mdi-arrow-up
      template(v-slot:item="{ item, index }")
        tr(
          @click="(e) => onClickRow(index)"
          :class="[selectedRowPosition === index && isHighlightSelectedRow ? 'selected-row' : '']"
        )
          td(
            v-for="header in headers"
            v-if="header.value in item || header.cellType === CELL_TYPE.default_no"
            :rowspan="header.rowspan ? header.rowspan : 1"
            :class="focusPosition !== null && focusPosition === index ?(header.cellType === CELL_TYPE.checkbox ? 'focus-cell focus-checkbox' : isHighlightFocusRow ? 'focus-cell focus-normal-cell' : '') : ''"
          )
            div(v-if="isWaitingData")
              v-skeleton-loader.px-2(type="text")
            div.wrapper-cell(
              v-else-if="(header?.hiddenCellIds ? !header.hiddenCellIds.includes(index) : true) && visibleCondition(item, header)"
              :class="[item.disabledBucket.indexOf(header.value) > -1 ? 'disabled-cell' : '']"
              :style="{background: (readonlyRowIds.includes(index) ? '#d0d0d0' : (mouseOverPosition === index ? 'rgb(225, 245, 254)' : ((header?.colBackground ? header.colBackground : '')))), justifyContent: header.align, alignItems: header?.verticalAlign}"
              v-next-focus="isUsingVNextFocus ? 'default' : 'disabled'"
            )
              span(
                v-if="header?.cellType === CELL_TYPE.default_no"
                :id="cellIdGenerator(header.value, index)"
              ) {{index + 1}}
              span(
                v-else-if="header?.cellType === CELL_TYPE.checkbox"
                :id="cellIdGenerator(header.value, index)"
              )
                div
                  v-simple-checkbox(
                    v-model="item[header.value]"
                    @input="(value) => onInputCheckbox(value, header)"
                    @click="(e) => onClickRow(index)"
                    color="primary"
                    :disabled="item.disabledBucket.indexOf(header.value) > -1  || disabledCondition(item, header)"
                  )
              span(
                v-else-if="header?.cellType === CELL_TYPE.text"
                :style="getCustomStyle(item, header, index)"
                :id="cellIdGenerator(header.value, index)"
              )
                slot(:name="'text-cell-' + header.value" :item="item" :headers="headers" :index="index")
                  span {{cellWrapper(item[header.value], header)}}
              .input-container(
                v-else-if="header?.cellType === CELL_TYPE.input"
                :class="[header?.outlined && item.disabledBucket.indexOf(header.value) === -1 ? 'input-outlined outlined-padding' : 'disable-input-outlined outlined-padding']"
              )
                input(
                  :disabled="item.disabledBucket.indexOf(header.value) > -1  || disabledCondition(item, header)"
                  type="text"
                  autocomplete="off"
                  :value="getInputValue(header, item, index)"
                  :class="header.class"
                  :id="cellIdGenerator(header.value, index)"
                  :ref="cellIdGenerator(header.value, index)"
                  :style="getCustomStyle(item, header, index)"
                  @input="onTypingInput(cellIdGenerator(header.value, index), item, header, index)"
                  @blur="onBlurInput(cellIdGenerator(header.value, index), item, header, index)"
                  @focus="onFocusInput(cellIdGenerator(header.value, index), item, header)"
                  @click="onClickInput(cellIdGenerator(header.value, index), item, header)"
                  @keyup="(e) => onKeyUpInput(e, header, index)"
                  group="custom-input-table"
                )
                .outline-highlight(v-if="header?.outlined")
                .input-underline(v-if="!header?.outlined")
                .input-underline-on-focus(v-if="!header?.outlined")
              v-autocomplete(
                v-else-if="header?.cellType === CELL_TYPE.autocomplete"
                v-model="item[header.value]"
                :disabled="item.disabledBucket.indexOf(header.value) > -1 || disabledCondition(item, header)"
                :items="header.autocompleteItems"
                :item-text="header.autocompleteItemText"
                :item-value="header.autocompleteItemValue"
                :class="header.class"
                :id="cellIdGenerator(header.value, index)"
                :ref="cellIdGenerator(header.value, index)"
                :filter="header?.autocompleteFilter"
                :style="getCustomStyle(item, header, index)"
                :auto-select-first="header?.autoSelectFirst !== false"
                :select-on-focus="header?.selectOnFocus !== false"
                :clearable="header?.clearable === true"
                @focus="() => onFocusAutocomplete(header, index)"
                @keyup="(e) => onKeyUpInput(e, header, index)"
                @change="() => onChangeAutocomplete(header, index)"
                hide-details
                group="custom-input-table"
              )
              v-btn(
                v-else-if="header?.cellType === CELL_TYPE.button"
                :style="getCustomStyle(item, header, index)"
                :id="cellIdGenerator(header.value, index)"
                @click="() => onClickButton(item, header, index)"
                :disabled="item.disabledBucket.indexOf(header.value) > -1 || disabledCondition(item, header)"
                :icon="Boolean(header?.icon)"
                :height="header?.height"
                :outlined="header?.outlined"
              )
                v-icon(v-if="header?.icon") {{header?.icon}}
                span(v-else) {{header?.buttonText}}
              v-menu(v-else-if="header?.cellType === CELL_TYPE.menuButton && header?.menuItems" bottom left)
                template(v-slot:activator='{ on }')
                  v-btn(
                    color='primary',
                    dark,
                    class='mr-auto',
                    v-on='on',
                    icon,
                    :style="getCustomStyle(item, header, index)"
                    :id="cellIdGenerator(header.value, index)"
                    @click="() => onClickButton(item, header, index)"
                  )
                    v-icon {{header?.icon}}
                v-list(width="fit-content")
                  slot(name="menu-items" :items="header.menuItems")
              span(
                :style="{...getCustomStyle(item, header, index)}"
                :id="cellIdGenerator(header.value, index)"
                v-else
              ) {{cellWrapper(item[header.value], header)}}
          slot(:name="'append-td'" :item="item" :headers="headers" :isReadonly="readonlyRowIds.includes(index)" :index="index")
        tr(v-if="isDoubleRowMode")
          slot(:name="'sub-row'" :item="item" :headers="headers" :isReadonly="readonlyRowIds.includes(index)" :index="index")
      template(v-slot:no-data)
        div.w100per.text-center.d-flex.no-data-div
          span.no-data {{ $t('common.no_data') }}
      template(v-slot:body.append)
        tr.loading-row(v-if="loading" id="loading-row")
          td(:colspan="headers.length")
            v-row
              v-col.text-center
                slot(name="loading")
                  v-progress-circular(:width='2' color='rgba(0, 0, 0, 0.32)' indeterminate='')
        tr.load-more(v-if="isUsingLoadMore && items.length")
          td(:colspan="headers.length" v-intersect="onLoadMore")
            v-row(v-if="isLoadMore")
              v-col.text-center
                v-progress-circular(:width='2' color='rgba(0, 0, 0, 0.32)' indeterminate='')
        tr.summary-row(v-if="isShowFooter" id="summary-row")
          td(v-for="header in headers" :style="{textAlign: header?.align, borderRight: 'none !important', borderLeft: 'none !important'}")
            div.wrapper-cell(:style="{justifyContent: header.align}")
              slot(:name="'footer-cell-' + header.value" :footer="footer" :header="header" :cellWrapper="cellWrapper")
                b(v-if="footer && header.value in footer") {{cellWrapper(footer[header.value], header)}}
</template>
<script>
import {
  defineComponent,
  ref,
  onMounted,
  getCurrentInstance,
  watch,
  onUnmounted
} from 'vue'
import { debounce } from 'lodash'

const CustomInputTable = defineComponent({
  props: {
    sortData: {
      type: Object,
      default: null
    }
  },
  setup(props, { emit }) {
    const tableId =
      Date.now().toString(36) + Math.random().toString(36).substr(2)
    const headers = ref([])
    const items = ref([])
    const footer = ref(undefined)
    const { $refs, $set } = getCurrentInstance().proxy
    const isShowFooter = ref(false)
    const isTableFocus = ref(false)
    const MOVE_DIRECTIONS = {
      horizontal: 0,
      vertical: 1
    }
    const CELL_TYPE = {
      default_no: 'default_no',
      checkbox: 'checkbox',
      text: 'text',
      input: 'input',
      button: 'button',
      menuButton: 'menuButton',
      autocomplete: 'autocomplete'
    }
    const DEFAULT_SORT_INFO = {
      sortBy: null,
      header: undefined,
      isDescending: false
    }
    const sortInfo = ref({ ...DEFAULT_SORT_INFO })
    const INPUT_FIELD_TYPES = [CELL_TYPE.input, CELL_TYPE.autocomplete]
    const moveDirection = ref(MOVE_DIRECTIONS.horizontal)

    const onInputListener = ref(undefined)
    const onTypingInputFieldListener = ref(undefined)
    const onChangeAutocompleteListener = ref(undefined)
    const onClickButtonListener = ref(undefined)
    const onFocusAutocompleteListener = ref(undefined)
    const onBackspaceListener = ref(undefined)
    const onChangeSelectedRowListener = ref(undefined)
    const onBeforeClickRowListener = ref(undefined)
    const onFocusPositionChangeListener = ref(undefined)
    const onLoadMoreListener = ref(undefined)

    const loading = ref(false)
    const mouseOverPosition = ref(null)
    const readonlyRowIds = ref([])
    const stickyTopPos = ref(0)
    const focusPosition = ref(null)
    const isAlwaysFocus = ref(false)
    const globalListeners = ref([])
    const scrollTopOffset = ref(62)
    const globalKeyDownLock = ref(false)
    const isHighlightFocusRow = ref(false)
    const selectedRowPosition = ref(null)
    const isHighlightSelectedRow = ref(false)
    const isDoubleRowMode = ref(false)
    const isDisableFocus = ref(false)
    const isUsingVNextFocus = ref(false)
    const customScrollElement = ref(undefined)
    const isUsingFocusInputOnEnter = ref(false)
    const isUsingAutoMovingFocus = ref(false)
    const onFocusingInputIndex = ref(null)
    const isLoadMore = ref(false)
    const isUsingLoadMore = ref(false)
    const isFirstTimeTriggerLoadMore = ref(false)
    const isWaitingData = ref(false)

    const resetSortInfo = () => {
      sortInfo.value = { ...DEFAULT_SORT_INFO }
    }
    const resetFocusPosition = () => {
      setFocusPosition(null)
    }
    const resetSelectedPosition = () => {
      selectedRowPosition.value = null
    }
    const cellIdGenerator = (headerName, rowId) => {
      return 't-' + tableId + ':' + headerName + '-' + rowId
    }
    const getCustomStyle = (item, header, rowIndex) => {
      // Can pass through custom color function in header:
      // color: (item, header, rowIndex) => {
      // [check condition]
      // return '[color]'
      // }
      return {
        color:
          header?.cellsColor && rowIndex in header?.cellsColor
            ? header?.cellsColor[rowIndex]
            : typeof header?.color === 'function'
            ? header.color(item, header, rowIndex)
            : header.color,
        backgroundColor:
          typeof header?.backgroundColor === 'function'
            ? header.backgroundColor(item, header, rowIndex)
            : header.backgroundColor,
        textAlign: header?.align,
        marginLeft: header?.marginLeft,
        marginRight: header?.marginRight
      }
    }

    const cellWrapper = (value, header) => {
      if (!header?.cellWrapper || typeof header.cellWrapper !== 'function')
        return value
      return header.cellWrapper(value)
    }
    const onInput = (item, header, value, index) => {
      if (typeof onInputListener.value !== 'function') return null
      return onInputListener.value(item, header, value, index)
    }
    const emitOnTypingInputField = (item, header, value, index) => {
      if (typeof onTypingInputFieldListener.value !== 'function') return null
      return onTypingInputFieldListener.value(item, header, value, index)
    }
    const onBlurInput = (elementId, item, header, index) => {
      const inputValue = document.getElementById(elementId).value
      const result = onInput(item, header, inputValue, index)
      document.getElementById(elementId).value = cellWrapper(
        item[header.value],
        header
      )
      // Set timeout to wait for all left events implement
      setTimeout(() => resolveAndClearResolver(), 20)
      return result
    }
    const onTypingInput = (elementId, item, header, index) => {
      const inputValue = document.getElementById(elementId).value
      emitOnTypingInputField(item, header, inputValue, index)
    }
    const onFocusInput = (elementId, item, header) => {
      // Wait resolver
      setAndAwaitResolver()
      document.getElementById(elementId).value = item[header.value]
    }
    const onChangeAutocomplete = (header, index) => {
      if (typeof onChangeAutocompleteListener.value !== 'function') return null
      const item = items.value[index]
      return onChangeAutocompleteListener.value(item, header, index)
    }
    // Resolver feature(await and resolve later): it helps onkeyup implements after all other actions
    const resolver = ref(undefined)
    const promise = ref(undefined)
    const setAndAwaitResolver = () => {
      if (promise.value) return
      promise.value = new Promise((resolve) => {
        resolver.value = resolve
      })
    }
    const resolveAndClearResolver = () => {
      resolver.value(true)
      promise.value = null
    }
    const doMove = (_thisElement, _nextElement) => {
      if ($refs[_nextElement] && $refs[_nextElement].length > 0) {
        $refs[_nextElement][0]?.focus()
        // Only input field can use select
        if (typeof $refs[_nextElement][0]?.select === 'function')
          $refs[_nextElement][0]?.select()
      }
    }
    const onKeyUpInput = debounce(async (evt, header, rowIndex) => {
      // If using v-next-focus then return
      if (isUsingVNextFocus.value) return
      // If not hot keys, return immediately
      if (
        evt.key !== 'Enter' &&
        !(
          evt.shiftKey &&
          ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes(evt.key)
        )
      )
        return
      const thisElement = cellIdGenerator(header.value, rowIndex)
      // Blur input first
      if ($refs[thisElement] && $refs[thisElement].length > 0)
        $refs[thisElement][0]?.blur()
      // Wait for all the action done
      await promise.value
      // Build active input cells map
      const activeInputCellsMap = []

      const inputHeaders = headers.value.filter(
        (header) => INPUT_FIELD_TYPES.indexOf(header.cellType) > -1
      )

      const inputColKeys = inputHeaders.map((header) => header.value)

      items.value.forEach((item) => {
        const activeInputCells = []
        inputHeaders.forEach((header) => {
          if (
            item.disabledBucket.indexOf(header.value) < 0 &&
            !disabledCondition(item, header)
          ) {
            activeInputCells.push(header.value)
          } else {
            activeInputCells.push(null)
          }
        })
        activeInputCellsMap.push(activeInputCells)
      })
      const goLeft = () => {
        const candidatesMap = []
        for (let i = 0; i <= rowIndex; i += 1) {
          if (i < rowIndex) {
            candidatesMap.push(activeInputCellsMap[i])
          } else {
            const currentHeaderIndex = activeInputCellsMap[i].indexOf(
              header.value
            )
            candidatesMap.push(
              activeInputCellsMap[i].slice(0, currentHeaderIndex)
            )
          }
        }
        const result = {
          header: null,
          index: null
        }
        for (let i = candidatesMap.length - 1; i >= 0; i -= 1) {
          for (let j = candidatesMap[i].length - 1; j >= 0; j -= 1) {
            if (candidatesMap[i][j] !== null) {
              result.header = candidatesMap[i][j]
              result.index = i
              break
            }
          }
          if (result.header) break
        }
        return result
      }
      const goRight = () => {
        const candidatesMap = []
        for (let i = 0; i < activeInputCellsMap.length; i += 1) {
          if (i < rowIndex) {
            candidatesMap.push([])
          } else if (i === rowIndex) {
            const currentHeaderIndex = activeInputCellsMap[i].indexOf(
              header.value
            )
            candidatesMap.push(
              activeInputCellsMap[i].slice(
                currentHeaderIndex + 1,
                inputColKeys.length
              )
            )
          } else {
            candidatesMap.push(activeInputCellsMap[i])
          }
        }
        const result = {
          header: null,
          index: null
        }
        for (let i = 0; i < candidatesMap.length; i += 1) {
          for (let j = 0; j < candidatesMap[i].length; j += 1) {
            if (candidatesMap[i][j] !== null) {
              result.header = candidatesMap[i][j]
              result.index = i
              break
            }
          }
          if (result.header) break
        }
        return result
      }
      const goTop = () => {
        const candidatesMap = []
        for (let i = 0; i < activeInputCellsMap.length; i += 1) {
          const currentHeaderIndex = activeInputCellsMap[i].indexOf(
            header.value
          )
          if (i < rowIndex) {
            candidatesMap.push(
              activeInputCellsMap[i].slice(0, currentHeaderIndex + 1)
            )
          } else if (i >= rowIndex) {
            candidatesMap.push(
              activeInputCellsMap[i].slice(0, currentHeaderIndex)
            )
          }
        }
        const result = {
          header: null,
          index: null
        }
        const currentKeyIndex = inputColKeys.indexOf(header.value)
        const leftSideKeys = inputColKeys.slice(0, currentKeyIndex + 1)
        for (let ki = leftSideKeys.length - 1; ki >= 0; ki -= 1) {
          for (let i = candidatesMap.length - 1; i >= 0; i -= 1) {
            if (candidatesMap[i].indexOf(leftSideKeys[ki]) > -1) {
              result.header = leftSideKeys[ki]
              result.index = i
              break
            }
          }
          if (result.header) break
        }
        return result
      }
      const goBottom = () => {
        const candidatesMap = []
        for (let i = 0; i < activeInputCellsMap.length; i += 1) {
          const currentHeaderIndex = activeInputCellsMap[i].indexOf(
            header.value
          )
          if (i <= rowIndex) {
            candidatesMap.push(
              activeInputCellsMap[i].slice(
                currentHeaderIndex + 1,
                inputColKeys.length
              )
            )
          } else if (i > rowIndex) {
            candidatesMap.push(
              activeInputCellsMap[i].slice(
                currentHeaderIndex,
                inputColKeys.length
              )
            )
          }
        }
        const result = {
          header: null,
          index: null
        }
        const currentKeyIndex = inputColKeys.indexOf(header.value)
        const leftSideKeys = inputColKeys.slice(
          currentKeyIndex,
          inputColKeys.length
        )
        for (let ki = 0; ki < leftSideKeys.length; ki += 1) {
          for (let i = 0; i < candidatesMap.length; i += 1) {
            if (candidatesMap[i].indexOf(leftSideKeys[ki]) > -1) {
              result.header = leftSideKeys[ki]
              result.index = i
              break
            }
          }
          if (result.header) break
        }
        return result
      }
      const getRightElement = () => {
        const target = goRight()
        if (!target.header) return null
        onFocusingInputIndex.value = target.index
        return cellIdGenerator(target.header, target.index)
      }
      const getLeftElement = () => {
        const target = goLeft()
        if (!target.header) return null
        onFocusingInputIndex.value = target.index
        return cellIdGenerator(target.header, target.index)
      }
      const getBottomElement = () => {
        const target = goBottom()
        if (!target.header) return null
        onFocusingInputIndex.value = target.index
        return cellIdGenerator(target.header, target.index)
      }
      const getTopElement = () => {
        const target = goTop()
        if (!target.header) return null
        onFocusingInputIndex.value = target.index
        return cellIdGenerator(target.header, target.index)
      }
      let nextElement
      if (evt.key === 'Enter') {
        if (moveDirection.value === MOVE_DIRECTIONS.horizontal) {
          nextElement = getRightElement()
        } else {
          nextElement = getBottomElement()
        }
        doMove(thisElement, nextElement)
      }
      if (evt.shiftKey && evt.key === 'ArrowRight') {
        nextElement = getRightElement()
        doMove(thisElement, nextElement)
      }
      if (evt.shiftKey && evt.key === 'ArrowLeft') {
        nextElement = getLeftElement()
        doMove(thisElement, nextElement)
      }
      if (evt.shiftKey && evt.key === 'ArrowUp') {
        nextElement = getTopElement()
        doMove(thisElement, nextElement)
      }
      if (evt.shiftKey && evt.key === 'ArrowDown') {
        nextElement = getBottomElement()
        doMove(thisElement, nextElement)
      }
    })
    const onClickInput = (element, item, header) => {
      if ($refs[element] && $refs[element].length > 0) {
        $refs[element][0]?.focus()
        // Only input field can use select
        setTimeout(() => {
          document.getElementById(element).value = item[header.value]
          if (typeof $refs[element][0]?.select === 'function')
            $refs[element][0]?.select()
        })
      }
    }
    const changeSort = (header) => {
      if (sortInfo.value.sortBy === header.value) {
        sortInfo.value.isDescending = !sortInfo.value.isDescending
      } else {
        sortInfo.value.sortBy = header.value
        sortInfo.value.header = header
        sortInfo.value.isDescending = false
      }
      emit('sort-info', sortInfo.value)
    }
    const onClickButton = (item, header, rowIndex) => {
      if (typeof onClickButtonListener.value !== 'function') return
      return onClickButtonListener.value(item, header, rowIndex)
    }
    const setIsShowRows = (isShow) => {
      const tableElement = document.getElementById(tableId)
      const trElements = tableElement?.getElementsByTagName('tr')
      if (!trElements) return
      const HEADER_POSITION = 0
      const shouldNotHidePositions = [HEADER_POSITION]
      const shouldNotHideIds = ['summary-row', 'loading-row']
      for (let i = 0; i < trElements.length; i++) {
        const tr = trElements[i]
        const trId = tr?.id
        if (isShow) {
          tr.style.display = 'table-row'
        } else {
          if (
            shouldNotHideIds.includes(trId) ||
            shouldNotHidePositions.includes(i)
          )
            continue
          tr.style.display = 'none'
        }
      }
    }

    const setHeadersWidth = () => {
      const tableElement = document.getElementById(tableId)
      if (!tableElement) return
      const thElements = tableElement?.getElementsByTagName('th')
      for (let i = 0; i < thElements.length; i++) {
        const header = headers.value[i]
        const th = thElements[i]
        if (header?.width && typeof header.width === 'number')
          th.style.width = header?.width ? header.width.toString() + '%' : 0
        else if (header?.width && typeof header.width === 'string') {
          th.style.width = header.width
          th.style.minWidth = header.width
          th.style.maxWidth = header.width
        }
      }
    }
    const onInputCheckbox = (value, header) => {
      if (!value) {
        header.isSelectAll = false
      } else {
        if (items.value.every((item) => item[header.value])) {
          header.isSelectAll = true
        }
      }
    }
    const onInputHeaderCheckbox = (value, header) => {
      items.value.forEach((item) => {
        item[header.value] = header.disabled(item) ? false : value
      })
    }

    const moveViewIfNeeded = (isDown = true) => {
      const tds = document.getElementsByClassName('focus-cell')
      let rowElement = undefined
      if (tds.length > 0) {
        rowElement = tds[0].parentNode
      }
      if (!rowElement) return
      if (isDown) {
        if (isDoubleRowMode) rowElement = rowElement?.nextSibling
        if (
          rowElement?.nextSibling &&
          typeof rowElement.nextSibling?.scrollIntoView === 'function'
        )
          rowElement.nextSibling?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          })
      } else {
        if (isDoubleRowMode) rowElement = rowElement?.previousSibling
        if (rowElement?.previousSibling) {
          const rowRect = rowElement.previousSibling.getBoundingClientRect()
          // Handle custom scroll element
          if (customScrollElement.value) {
            const scrollElementTop =
              customScrollElement.value.getBoundingClientRect().top
            if (rowRect.top - scrollElementTop - scrollTopOffset.value < 0) {
              return (customScrollElement.value.scrollTop -= rowRect.height)
            }
          }
          if (rowRect.top - scrollTopOffset.value < 0) {
            document.documentElement.scrollTop -= rowRect.height
          }
        }
      }
    }
    const focusInputOnEnter = (rowIndex) => {
      if (rowIndex === null) return
      const item = items.value[rowIndex]
      headers.value.every((header) => {
        if (
          INPUT_FIELD_TYPES.includes(header.cellType) &&
          !item.disabledBucket.includes(header.value) &&
          !disabledCondition(items.value[rowIndex], header)
        ) {
          doMove(undefined, cellIdGenerator(header.value, rowIndex))
          return false
        }
        return true
      })
    }
    const onGlobalKeyUp = (e) => {
      if (!isTableFocus.value) return
      if (globalKeyDownLock.value) return
      const eventSource = event.target || event.srcElement
      if (eventSource?.tagName === 'INPUT') return
      if (e.code === 'Enter') {
        if (!isUsingFocusInputOnEnter.value) return
        // Focus input on enter if there is no focused input
        focusInputOnEnter(focusPosition.value)
      }
    }
    const onGlobalKeyDown = (e) => {
      if (!isTableFocus.value) return
      if (globalKeyDownLock.value) return
      const eventSource = event.target || event.srcElement
      if (eventSource?.tagName === 'INPUT') return
      if (!e.shiftKey && e.key === 'ArrowDown') {
        e.preventDefault()
        if (focusPosition.value < items.value.length - 1) {
          setFocusPosition(focusPosition.value + 1)
          moveViewIfNeeded(true)
        }
      }
      if (!e.shiftKey && e.key === 'ArrowUp') {
        e.preventDefault()
        if (focusPosition.value > 0) setFocusPosition(focusPosition.value - 1)
        moveViewIfNeeded(false)
      }
      if (e.code === 'Space') {
        e.preventDefault()
        if (typeof onBackspaceListener.value === 'function') {
          onBackspaceListener.value(focusPosition.value)
        }
      }
      if (e.code === 'Enter') {
        setSelectedRow(focusPosition.value)
      }
    }
    const setSelectedRow = (index) => {
      selectedRowPosition.value = index
      if (
        onChangeSelectedRowListener.value &&
        typeof onChangeSelectedRowListener.value === 'function'
      ) {
        onChangeSelectedRowListener.value(selectedRowPosition.value)
      }
    }
    const onClickRow = (index) => {
      if (isDisableFocus.value) return
      if (typeof onBeforeClickRowListener.value === 'function') {
        onBeforeClickRowListener.value(index)
      }
      isTableFocus.value = true
      setFocusPosition(index)
      setSelectedRow(index)
    }
    const disabledCondition = (item, header) => {
      if (typeof header?.disabled !== 'function') return false
      return header?.disabled(item)
    }
    const visibleCondition = (item, header) => {
      if (typeof header?.visible !== 'function') return true
      return header?.visible(item)
    }
    const onLoadMore = () => {
      if (!isFirstTimeTriggerLoadMore.value) {
        isFirstTimeTriggerLoadMore.value = true
        return
      }
      if (typeof onLoadMoreListener.value !== 'function') return
      onLoadMoreListener.value()
    }
    /* Watch zone */
    watch(
      sortInfo,
      () => {
        items.value = items.value.sort((item1, item2) => {
          return sortInfo.value.header?.sort(
            item1[sortInfo.value.sortBy],
            item2[sortInfo.value.sortBy],
            sortInfo.value.isDescending
          )
        })
      },
      { deep: true }
    )
    watch(
      focusPosition,
      () => {
        emit('change-focus-position', focusPosition.value)
      },
      { deep: true }
    )

    /*Publish apis*/
    const setHeaders = (_headers) => {
      headers.value = _headers
      setTimeout(() => setHeadersWidth())
    }
    const getItems = () => {
      return items.value
    }
    const setItems = (_items, isKeepFocusPosition = false) => {
      isFirstTimeTriggerLoadMore.value = false
      items.value = _items
      items.value.map((item) => {
        item.disabledBucket = []
      })
      if (isKeepFocusPosition) return
      props.sortData ? (sortInfo.value = props.sortData) : resetSortInfo()
      resetFocusPosition()
      resetSelectedPosition()
    }
    const concatItems = (newItems) => {
      newItems.map((item) => {
        item.disabledBucket = []
      })
      items.value = items.value.concat(newItems)
    }
    const getItemsLength = () => {
      return items.value.length
    }
    const addDisableCell = (index, header) => {
      if (items.value[index].disabledBucket.indexOf(header.value) >= 0) return
      if (typeof header === 'string')
        items.value[index].disabledBucket.push(header)
      else items.value[index].disabledBucket.push(header.value)
      // Must trigger reactive here
      $set(items.value, index, items.value[index])
    }
    const removeDisableCell = (index, header) => {
      items.value[index].disabledBucket.map((value, idx) => {
        if (typeof header === 'string' && value === header)
          items.value[index].disabledBucket.splice(idx, 1)
        else if (value === header.value)
          items.value[index].disabledBucket.splice(idx, 1)
      })
    }
    const setCellWrapper = (header, wrapperFunc) => {
      if (typeof wrapperFunc !== 'function') return
      return (header.cellWrapper = wrapperFunc)
    }
    const setHorizontalShift = () => {
      return (moveDirection.value = MOVE_DIRECTIONS.horizontal)
    }
    const setVerticalShift = () => {
      return (moveDirection.value = MOVE_DIRECTIONS.vertical)
    }
    const setCellTypeText = (header) => {
      header.cellType = CELL_TYPE.text
    }
    const setCellTypeInput = (header) => {
      header.cellType = CELL_TYPE.input
    }
    const setCellTypeAutocomplete = (header) => {
      header.cellType = CELL_TYPE.autocomplete
    }
    const setCellTypeButton = (header) => {
      header.cellType = CELL_TYPE.button
    }
    const setCellTypeMenuButton = (header) => {
      header.cellType = CELL_TYPE.menuButton
    }
    const setCellTypeBatch = (targetList, headers, setCellTypeFunc) => {
      headers.forEach((header) => {
        if (targetList.includes(header.value)) setCellTypeFunc(header)
      })
    }
    const appendReadonlyRowIds = (rowIndexes) => {
      const appendList = []
      rowIndexes.forEach((rowIndex) => {
        if (readonlyRowIds.value.indexOf(rowIndex) < 0) {
          appendList.push(rowIndex)
        }
      })
      readonlyRowIds.value = readonlyRowIds.value.concat(appendList)
    }
    const onFocusAutocomplete = (header, rowIndex) => {
      const item = items.value[rowIndex]
      // Implement on focus event listener
      if (typeof onFocusAutocompleteListener.value === 'function')
        onFocusAutocompleteListener.value(header, item, rowIndex)
      const thisElement = cellIdGenerator(header.value, rowIndex)
      const autocompleteRef = $refs[thisElement][0]
      autocompleteRef.isMenuActive = true
    }
    const clearReadonlyRow = (rowIndex) => {
      const readonlyIndex = readonlyRowIds.value.indexOf(rowIndex)
      if (readonlyIndex > -1) readonlyRowIds.value.splice(readonlyIndex, 1)
    }
    const clearAllReadOnlyRowIds = () => {
      readonlyRowIds.value = []
    }
    const updateCellColor = (header, isClear = false) => {
      if (header?.cellsColor) {
        for (const id in Object.keys(header.cellsColor)) {
          const element = document.getElementById(
            cellIdGenerator(header.value, id)
          )
          if (!element) continue
          if (isClear) {
            element.style.color = header?.color
            return
          }
          element.style.color = header.cellsColor[id]
        }
      }
    }
    const setCellsColor = (header, cellColors) => {
      updateCellColor(header, true)
      header.cellsColor = cellColors
      updateCellColor(header)
    }
    const setHiddenCellIds = (header, hiddenCellIds) => {
      header.hiddenCellIds = hiddenCellIds
    }
    const setOnInputListener = (listener) => {
      onInputListener.value = listener
    }
    const setOnTypingInputListener = (listener) => {
      onTypingInputFieldListener.value = listener
    }
    const setOnClickButtonListener = (listener) => {
      onClickButtonListener.value = listener
    }
    const setOnFocusAutocompleteListener = (listener) => {
      onFocusAutocompleteListener.value = listener
    }
    const setOnChangeAutocompleteListener = (listener) => {
      onChangeAutocompleteListener.value = listener
    }
    const setOnBackspaceListener = (listener) => {
      onBackspaceListener.value = listener
    }
    const setOnChangeSelectedRowListener = (listener) => {
      onChangeSelectedRowListener.value = listener
    }
    const setOnBeforeClickRowListener = (listener) => {
      onBeforeClickRowListener.value = listener
    }
    const setOnFocusPositionChangeListener = (listener) => {
      onFocusPositionChangeListener.value = listener
    }
    const setOnLoadMoreListener = (listener) => {
      onLoadMoreListener.value = listener
    }
    const setIsLoading = (value) => {
      loading.value = value
      if (!loading.value) setIsShowRows(true)
      else setIsShowRows(false)
    }
    const setIsWaitingData = (value) => {
      isWaitingData.value = value
    }
    const setIsLoadMore = (value) => {
      isLoadMore.value = value
    }
    const setIsShowFooter = (value) => {
      isShowFooter.value = value
    }
    const setFooter = (_footer) => {
      footer.value = _footer
    }
    const setMenuItems = (header, menuItems) => {
      header.menuItems = menuItems
    }
    const setInputFieldValue = (value, header, rowIndex) => {
      const elementId = cellIdGenerator(header.value, rowIndex)
      if (!value) value = ''
      const inputElement = document.getElementById(elementId)
      inputElement.value = value
    }
    const setAutocompleteItems = (items, header) => {
      header.autocompleteItems = items.map((item) =>
        JSON.parse(JSON.stringify(item))
      )
    }
    const setStickyHeaderPosition = (value) => {
      stickyTopPos.value = value
    }
    const resetCheckBoxAll = (header) => {
      if (items.value.length === 0) return (header.isSelectAll = false)
      return (header.isSelectAll = items.value.every(
        (item) => item[header.value]
      ))
    }
    const focus = (index = 0) => {
      isTableFocus.value = true
      setFocusPosition(index)
    }
    const focusAndSelectFirst = () => {
      isTableFocus.value = true
      setFocusPosition(0)
      setSelectedRow(0)
    }
    const blurActiveInput = () => {
      // Blur active input if table is blur
      if (document.querySelector) {
        const focused = document.getElementById(tableId).querySelector(':focus')
        if (focused) {
          // Check focus input is the table's element or not
          const focusedElementId = focused.id
          if (focusedElementId.includes(tableId)) {
            focused?.blur()
          }
        }
      }
    }
    const blur = () => {
      isTableFocus.value = false
      blurActiveInput()
      resetFocusPosition()
    }
    const isFocused = () => {
      return isTableFocus.value
    }
    const setIsAlwaysFocus = (value) => {
      isAlwaysFocus.value = value
    }
    const setScrollTopOffset = (value) => {
      scrollTopOffset.value = value
    }
    const setFocusPosition = (value) => {
      focusPosition.value = value
      if (typeof onFocusPositionChangeListener.value === 'function')
        onFocusPositionChangeListener.value(value)
    }
    const getFocusPosition = () => {
      return focusPosition.value
    }
    const setGlobalKeyDownLock = (value) => {
      globalKeyDownLock.value = value
    }
    const setIsHighlightFocusRow = (value) => {
      isHighlightFocusRow.value = value
    }
    const setIsHighlightSelectedRow = (value) => {
      isHighlightSelectedRow.value = value
    }
    const setIsDoubleRowMode = (value) => {
      isDoubleRowMode.value = value
    }
    const setIsDisableFocus = (value) => {
      isDisableFocus.value = value
    }
    const setIsUsingVNextFocus = (value) => {
      isUsingVNextFocus.value = value
    }
    const setCustomScrollElement = (htmlElement) => {
      customScrollElement.value = htmlElement
    }
    const setIsUsingFocusInputOnEnter = (value) => {
      isUsingFocusInputOnEnter.value = value
    }
    const setIsUsingAutoMovingFocus = (value) => {
      isUsingAutoMovingFocus.value = value
    }
    const setIsUsingLoadMore = (value) => {
      isUsingLoadMore.value = value
    }
    const getInputValue = (header, item, index) => {
      if (!document.activeElement)
        return cellWrapper(item[header.value], header)
      return document.activeElement.id === cellIdGenerator(header.value, index)
        ? item[header.value]
        : cellWrapper(item[header.value], header)
    }
    const moveCursorDown = () => {
      isTableFocus.value = true
      if (focusPosition.value === items.value.length - 1) return
      setFocusPosition(focusPosition.value + 1)
      moveViewIfNeeded()
    }
    const moveCursorUp = () => {
      isTableFocus.value = true
      if (focusPosition.value === 0) return
      setFocusPosition(focusPosition.value - 1)
      moveViewIfNeeded(false)
    }
    const APIs = {
      // Set header
      /* Properties:
        headers (ref: Array): This is a reactive reference that holds an array of objects representing the table headers. Each object can have the following properties:
          text (string, required): The text to be displayed in the header cell.
          value (string, required): A unique value used for referencing the header and accessing data in the corresponding column of the table.
          sortable (boolean, optional): Determines whether the header can be clicked to sort the table by this column. Defaults to false.
          align (string, optional): Horizontal alignment of the content in the header cell. Possible values include "left", "center", and "right". Defaults to "left".
          width (string or number, optional): The width of the header cell. Can be a fixed value in pixels (e.g., "100px") or a percentage (e.g., "20%").
          cellType (string, optional): Specifies the type of data displayed in the corresponding column and how the cell should be rendered. Possible values include:
            "default_no" (default): Renders the cell value without any special formatting.
            "checkbox": Renders a checkbox for interacting with data.
            "text": Renders the cell value with basic text formatting.
            "input": Renders an input field for editing the cell value.
            "button": Renders a button for performing actions on the data.
            "menuButton": Renders a button that triggers a menu for interacting with the data.
            "autocomplete": Renders an autocomplete input field for selecting values.
          cellsColor (object, optional): An object where keys are indexes of rows and values are colors to be applied to the background of the corresponding cell in that row.
          color (function or string, optional): A function that takes the item data, header object, and row index as arguments and returns the color for the cell's text. Alternatively, you can provide a string representing a static color.
          backgroundColor (function or string, optional): Similar to color, but determines the background color of the cell.
          marginLeft (string or number, optional): The left margin of the content in the header cell.
          marginRight (string or number, optional): The right margin of the content in the header cell.
          cellWrapper (function, optional): A function that takes the cell value and the header object as arguments and returns the formatted value for display.
          hiddenCellIds (array of numbers, optional): An array of row indexes where this header should be hidden in the corresponding cells.
          disabled (boolean, optional): Disables interaction with the header (e.g., sorting). Defaults to false.
          autocompleteItems (array, optional): An array of items to be displayed in the autocomplete dropdown for this header. Required when cellType is "autocomplete".
          autocompleteItemText (function, optional): A function that takes an item from autocompleteItems and returns the text to be displayed for that item in the dropdown.
          autocompleteItemValue (function, optional): A function that takes an item from autocompleteItems and returns the value to be used when the item is selected.
          class (string, optional): CSS class names to be applied to the header cell.
          icon (string, optional): The name of an icon to be displayed in the header cell (used for button and menuButton cell types).
          outlined (boolean, optional): Whether to render the input field with an outline style (used for input cell type).
          height (string or number, optional): The height of the button cell (used for button cell type).
          isShowCheckboxAll (boolean, optional): Determines whether to display a select-all checkbox in the header cell when cellType is "checkbox". Defaults to false.
          autocompleteFilter (function, optional): A function used to filter the items displayed in the autocomplete dropdown.
          colBackground (string or function, optional): Similar to backgroundColor, but specific to the entire column (all cells) instead of individual cells.
          rowspan (number, optional): Specifies the number of rows spanned by this header. Defaults to 1.
          headerAlign (string, optional): Similar
      */
      /* Header format:
      Text:
       {
          text: $root.$t('table_common.text'),
          value: 'value',
          cellType: 'text',
          align: 'center',
          sortable: false,
          width: 7,
          color: undefined,
          colBackground: 'lightgrey'
        }
      Input:
       {
          text: $root.$t('table_common.text'),
          value: 'value',
          cellType: 'input',
          align: 'center',
          sortable: false,
          width: 7,
          color: undefined,
          colBackground: 'lightgrey'
        }
      Autocomplete:
        {
          text: $root.$t('table_common.slip_type'),
          value: 'slip_type',
          cellType: 'autocomplete',
          align: 'center',
          sortable: false,
          width: 7,
          color: undefined,
          autocompleteItems: [],
          itemText: (item) => item.text,
          itemValue: (item) => item.code,
          colBackground: 'lightgrey'
        }
      */
      setHeaders,
      // Set item
      setItems,
      getItems,
      concatItems,
      getItemsLength,
      resetCheckBoxAll,
      // Set item of autocomplete
      setAutocompleteItems,
      // Set footer
      setFooter,
      setIsShowFooter,
      // Set move direction
      setHorizontalShift,
      setVerticalShift,
      // Set cell wrapper
      setCellWrapper,
      // Set cell cursor
      setCellsColor,
      // Set loading
      setIsLoading,
      setIsUsingLoadMore,
      setIsLoadMore,
      setIsWaitingData,
      // Set menu item
      setMenuItems,
      // Set hidden cell
      setHiddenCellIds,
      // Set cell type(If needed)
      setCellTypeText,
      setCellTypeInput,
      setCellTypeButton,
      setCellTypeMenuButton,
      setCellTypeAutocomplete,
      setCellTypeBatch,
      // Set readonly rows
      appendReadonlyRowIds,
      clearReadonlyRow,
      clearAllReadOnlyRowIds,
      // Set input value
      setInputFieldValue,
      // Set listeners
      setOnInputListener,
      setOnTypingInputListener,
      setOnClickButtonListener,
      setOnFocusAutocompleteListener,
      setOnChangeAutocompleteListener,
      setOnBackspaceListener,
      setOnChangeSelectedRowListener,
      setOnBeforeClickRowListener,
      setOnFocusPositionChangeListener,
      setOnLoadMoreListener,
      // DisabledBucket
      addDisableCell,
      removeDisableCell,
      // Set sticky top position
      setStickyHeaderPosition,
      // Set focus
      focus,
      focusAndSelectFirst,
      isFocused,
      blur,
      blurActiveInput,
      setIsAlwaysFocus,
      setIsHighlightFocusRow,
      getFocusPosition,
      setFocusPosition,
      setIsDisableFocus,
      // Set selected
      setIsHighlightSelectedRow,
      setSelectedRow,
      // Set scrollbar to offset
      setScrollTopOffset,
      setCustomScrollElement,
      // Set lock for the global event: keydown for keys: backspace, arrow down, up
      setGlobalKeyDownLock,
      // Double row enable
      setIsDoubleRowMode,
      // Set is using v next focus or not (default false), if false using custom move direction func instead
      setIsUsingVNextFocus,
      // Using focus input on enter feature, if row is focused and press enter, autofocus the first input of the row
      setIsUsingFocusInputOnEnter,
      // Using set focus position bases on current focused input
      setIsUsingAutoMovingFocus,
      moveCursorDown,
      moveCursorUp
    }
    const publishAPIs = () => {
      emit('apis', APIs)
    }
    watch(onFocusingInputIndex, () => {
      if (isUsingAutoMovingFocus.value) {
        setFocusPosition(onFocusingInputIndex.value)
      }
    })
    onMounted(() => {
      const onKeyDown = (e) => onGlobalKeyDown(e)
      const onKeyUp = (e) => onGlobalKeyUp(e)
      const clickOutSide = (e) => {
        if (!document.getElementById(tableId)?.contains(e.target)) {
          // Clicked outside the box
          if (isAlwaysFocus.value) return
          resetFocusPosition()
          isTableFocus.value = false
        }
      }
      globalListeners.value.push({
        key: 'keydown',
        value: onKeyDown
      })
      globalListeners.value.push({
        key: 'keyup',
        value: onKeyUp
      })
      globalListeners.value.push({
        key: 'mousedown',
        value: clickOutSide
      })
      document.addEventListener('keydown', onKeyDown)
      document.addEventListener('keyup', onKeyUp)
      document.addEventListener('mousedown', clickOutSide)
      // Publish apis
      publishAPIs()
      emit('on-mounted')
    })
    onUnmounted(() => {
      emit('on-unmounted')
      for (let i = 0; i < globalListeners.value.length; i += 1) {
        document.removeEventListener(
          globalListeners.value[i].key,
          globalListeners.value[i].value
        )
      }
    })
    return {
      tableId,
      headers,
      items,
      footer,
      CELL_TYPE,
      loading,
      readonlyRowIds,
      isShowFooter,
      mouseOverPosition,
      sortInfo,
      stickyTopPos,
      focusPosition,
      isHighlightFocusRow,
      selectedRowPosition,
      isHighlightSelectedRow,
      isDoubleRowMode,
      isUsingVNextFocus,
      isLoadMore,
      isUsingLoadMore,
      isWaitingData,
      getCustomStyle,
      cellWrapper,
      onBlurInput,
      onClickInput,
      onKeyUpInput,
      onClickButton,
      onFocusAutocomplete,
      onChangeAutocomplete,
      cellIdGenerator,
      onFocusInput,
      changeSort,
      onInputHeaderCheckbox,
      onInputCheckbox,
      onGlobalKeyDown,
      onClickRow,
      onLoadMore,
      disabledCondition,
      visibleCondition,
      onTypingInput,
      getInputValue
    }
  }
})

export default CustomInputTable
</script>

<style scoped lang="sass">
.cut-pot
  display: contents
.main
  margin: 0 auto
.text-start
  padding: 0
  overflow-x: scroll
  overflow-y: hidden
  > table
    > tbody > tr > td
      font-size: 16px !important
      cursor: pointer
    > thead > tr > th
      color: white !important
      font-weight: bold
      font-size: 16px !important
      .v-input--selection-controls__input
        margin-right: 0px !important
.custom::v-deep .v-data-table > .v-data-table__wrapper
  > table
    border-collapse: collapse !important
    > tbody > tr > td
      height: 28px !important
.total
  text-align: right !important
::v-deep .v-data-table > .v-data-table__wrapper
  max-height: 100% !important
  min-height: 100% !important
  overflow: unset
.table-wrapper
  max-height: 100% !important
  min-height: 100% !important
  overflow: unset
input
  text-align: right
  width: 100%
::v-deep table > thead > tr > th
  position: sticky
  top: 0
  background-color: var(--v-primary-base) !important
::v-deep table > thead > tr > th > .wrapper-header
  color: white !important
  font-size: 16px
  font-weight: bold !important
input:focus
  outline: none
.input-underline
  border-bottom: 1px solid #008037
  width: 100%
.input-underline-on-focus
  width: 100%
  border-bottom: 2px solid #008037
  transform: scaleX(0)
input:focus ~ .input-underline-on-focus
  transform: scaleX(1) translate(0, -1px)
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)
input:disabled ~ .input-underline
  border-image: repeating-linear-gradient(to right, rgba(0, 0, 0, 0.38) 0px, rgba(0, 0, 0, 0.38) 2px, transparent 2px, transparent 4px) 1 repeat
.information-list
  background-color: white
::v-deep .v-btn--icon.v-size--default
  height: 18px !important
  width: 18px !important
.custom-input-table
  ::v-deep .v-data-table__wrapper > table > thead > tr
    > th
      padding: 0 4px
    > th:last-child
      border-right: 0 !important
  ::v-deep .v-data-table__wrapper > table > tbody > tr
    > td
      padding: 0 0
.wrapper-cell
  display: flex
  align-items: center
  height: 100%
  width: 100%
  padding: 0 4px
  font-size: 16px !important
.chip-select-date
  height: 20px !important
.search-chip
  height: 20px !important
.text-stem-have-date
  font-size: 16px
  font-weight: normal !important
  color: #000000
::v-deep .v-text-field
  padding-top: 0 !important
  margin-top: 0 !important
  margin-bottom: 5px
  input
    padding: 0 0 !important
::v-deep .v-text-field .v-input__prepend-inner, .v-text-field .v-input__append-inner
  margin-top: 0 !important
.custom-input-table-wrapper
  max-height: 100% !important
  min-height: 100% !important
  overflow: unset
::v-deep table tr:hover:not(.v-table__expanded__content)
  background: transparent !important
input[type="text"][disabled]
   color: rgba(0, 0, 0, 0.87)
.border-checkbox i
  background-color: white
  border-radius: 5px
::v-deep .v-input--selection-controls__input
  margin-right: 0 !important
::v-deep .focus-checkbox
  border: 2px solid #008037bf !important
::v-deep .focus-normal-cell
  background: #e2ffb9 !important
::v-deep .selected-row
  td:first-child
    border-left: 2px solid #008037bf !important
  td:last-child
    border-right: 2px solid #008037bf !important
  td
    border-top: 2px solid #008037bf !important
    border-bottom: 2px solid #008037bf !important
.wrapper-header
  display: flex
  align-items: center
  height: 100%
  width: 100%
  font-size: 16px !important
  justify-content: center
.input-outlined
  border: 1px solid #008037bf !important
.input-outlined:focus-within
  border: 2px solid #008037bf !important
.outlined-padding
  border-radius: 4px
  padding: 0 4px
.no-data-div
  height: 36px
  align-items: center
  justify-content: center
</style>
